<app-rc-dialog-wrapper (closePopin)="onClose()">
  <div class="outer-wrapper">
    <div class="wrapper">
      @switch (data?.type) {
        @case ('email') {
          <div class="share-reco__section share-reco__email">
            <div class="img-wrapper">
              <img src="assets/svg/send.svg" alt="" />
            </div>
            <div class="text-block">
              <h3 class="rc-title-gamma">{{ 'email-success_title' | translateKey }}</h3>
              <p class="rc-paragraph">{{ 'email-success_text' | translateKey }}</p>
            </div>
          </div>
        }
        @case ('download') {
          <div class="share-reco__section share-reco__download">
            <div class="img-wrapper">
              <img src="assets/svg/download-cloud.svg" alt="" />
            </div>
            <div class="text-block">
              <h3 class="rc-title-gamma">{{ 'po-letter-downloaded_title' | translateKey }}</h3>
              <p class="rc-paragraph">{{ 'po-letter-downloaded_text' | translateKey }}</p>
            </div>
          </div>
        }
        @case ('qrcode') {
          <div class="share-reco__section share-reco__qrcode">
            @if (data.qrCodeLink) {
              <div class="img-wrapper qrCode">
                <img src="{{ data.qrCodeLink }}" alt="" />
              </div>
            }
            <div class="text-block">
              <h3 class="rc-title-gamma">{{ 'po-letter_settings_instructions' | translateKey }}</h3>
              <p class="rc-paragraph">{{ 'po-letter_settings_instructions_text' | translateKey }}</p>
            </div>
          </div>
        }
        @case ('saveConsultation') {
          <div class="share-reco__section share-reco__saveConsultation">
            <div class="share-reco__saveConsultation__content">
              <h3 class="rc-title-gamma rc-title-gamma--thin">{{ data?.title || ('title_save-the-consultation' | translateKey) }}</h3>
              <p class="rc-paragraph" i18n="@@create-patient_discover-benefits">Discover the benefits:</p>
              <ul class="benefits-list">
                <li class="benefits-list__item">
                  <span class="rc-paragraph" i18n="@@create-patient_individual-nutrition-plan">Individual nutritional plan</span>
                </li>
                <li class="benefits-list__item">
                  <span class="rc-paragraph" i18n="@@create-patient_calculated-daily-ration">Calculated daily ration</span>
                </li>
                <li class="benefits-list__item">
                  <span class="rc-paragraph" i18n="@@create-patient_patient-follow-up">Patient follow up</span>
                </li>
              </ul>
            </div>
          </div>
        }
      }
      @if (!data?.showSaveConsultationForm) {
        <div class="actions">
          @if (data?.showSaveConsultationBtn) {
            <rc-button
              id="saveConsultationBtn"
              data-qa="vs-share-recommendation-page-popin-button-save-consumtation"
              (click)="onSaveConsultation()"
            >
              {{ 'action_save-consultation' | translateKey }}
            </rc-button>
          }
          @if (data?.showBackToHomepageBtn) {
            <rc-button
              id="backToHomepageBtn"
              data-qa="vs-share-recommendation-page-popin-button-redirect-to-homepage"
              variant="quinary"
              (click)="onBackToHomepage()"
            >
              {{ 'action_redirect-to-homepage' | translateKey }}
            </rc-button>
          }
        </div>
      }
    </div>
    @if (data?.showSaveConsultationForm) {
      @let state = state$ | async;
      @let scanningMails = scanningMails$ | async;
      <div class="wrapper">
        <form class="save-consultation__form rc-dialog-form" [formGroup]="form" (submit)="onSaveConsultation()">
          <h3 class="rc-title-gamma rc-title-gamma--thin">{{ 'title_save-the-consultation' | translateKey }}</h3>
          <div class="rc-dialog-form__input">
            <rc-field
              id="save-consultation-field-givenName"
              formControlName="givenName"
              [label]="'form-attribute_owner-first-name' | translateKey"
              [error]="nameErrorMessage('givenName', 'form-attribute_owner-first-name', Constants.SHORTER_PET_OWNER_FIRST_NAME_KEY)"
            >
            </rc-field>
          </div>
          <div class="rc-dialog-form__input">
            <rc-field
              id="save-consultation-field-familyName"
              formControlName="familyName"
              [label]="'form-attribute_owner-last-name' | translateKey"
              [error]="nameErrorMessage('familyName', 'form-attribute_owner-last-name', Constants.SHORTER_PET_OWNER_LAST_NAME_KEY)"
            >
            </rc-field>
          </div>
          <div class="rc-dialog-form__input">
            <rc-field
              id="save-consultation-field-email"
              formControlName="email"
              [label]="'form-attribute_owner-email' | translateKey"
              [error]="emailErrorMessage()"
            >
            </rc-field>
            @if (scanningMails) {
              <div class="rc-field-hint rc-input--info-message">
                <span>{{ 'create-patient_looking-for-pet-owner' | translateKey }}</span>
              </div>
            } @else {
              @if (state === CreatePatientStates.MailExists) {
                <div class="rc-field-hint rc-input--ok-message">
                  <span>{{ 'save-new-pet_existing-pet-owner' | translateKey }}</span>
                </div>
              }
              @if (state === CreatePatientStates.Error) {
                <div class="rc-field-hint rc-input--error-message">
                  <span>{{ 'error_general_text' | translateKey }}</span>
                </div>
              }
            }
          </div>
          <div class="field-wrapper phone-wrapper field-wrapper-right" id="save-consultation-field-telephone">
            <rc-phone-field formControlName="telephone" [label]="'form-attribute_phone' | translateKey" [error]="phoneErrorMessage()">
            </rc-phone-field>
          </div>
          @if (state !== CreatePatientStates.Error) {
            <div class="consent">
              <app-checkbox
                id="confirmContent"
                formControlName="consent"
                [multiLine]="true"
                [label]="'create-patient_legal' | translateKey"
              ></app-checkbox>
            </div>
          }
          <div class="actions">
            <rc-button
              id="saveConsultationFormBtn"
              data-qa="vs-share-recommendation-page-popin-form-button-save-consumtation"
              type="submit"
              [disabled]="form.invalid || state === CreatePatientStates.Error"
            >
              {{ 'action_save-consultation' | translateKey }}
            </rc-button>
            @if (data?.type !== 'saveConsultation') {
              <rc-button
                data-qa="vs-share-recommendation-page-popin-form-button-redirect-to-homepage"
                variant="quinary"
                (click)="onBackToHomepage()"
              >
                {{ 'action_redirect-to-homepage' | translateKey }}
              </rc-button>
            }
          </div>
        </form>
      </div>
    }
  </div>
</app-rc-dialog-wrapper>
